import * as React from "react";
// import ctl from "@netlify/classnames-template-literals";

const HeaderNews = ({ path }) => {
  return <></>;
};

export { HeaderNews };
